module.exports = __webpack_public_path__ + "static/bg-page-3-079786d05f3ea90fcd45762db4a416fd.jpg";